import { VStack } from "@chakra-ui/layout";
import { Input, Text, InputGroup } from "@chakra-ui/react";
import React, { ReactNode } from "react";

interface Props {
	value: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	label?: string;
	placeHolder?: string;
	labelFontWeight?: number;
	width?: number | string;
	type?: string;
	disabled?: boolean;
	inputIcon?: ReactNode;
	readOnly?: boolean;
	isInvalid?: boolean;
}

const SimpleInput = ({
	labelFontWeight = 700,
	width = 300,
	type = "text",
	label = "",
	onChange = undefined,
	placeHolder,
	value,
	disabled = false,
	readOnly = false,
	inputIcon = null,
	isInvalid = false,
}: Props) => {
	return (
		<VStack alignItems="start" width={{ base: "100%", md: width }} spacing="2">
			{label && (
				<Text fontSize="14px" fontWeight={labelFontWeight} m={0}>
					{label}
				</Text>
			)}
			<InputGroup>
				<Input
					readOnly={readOnly}
					type={type}
					placeholder={placeHolder}
					fontSize="14px"
					borderRadius={"14px"}
					onChange={onChange}
					value={value}
					isDisabled={disabled}
					isInvalid={isInvalid}
				/>
				{inputIcon}
			</InputGroup>
		</VStack>
	);
};

export default SimpleInput;
